import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ProjectTypeService } from '../Services/project-type.service';
import { ProjectType } from '../objects/ProjectType';

@Component({
  selector: 'app-admin-project-types',
  templateUrl: './admin-project-types.component.html',
  styleUrls: ['./admin-project-types.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminProjectTypesComponent implements OnInit {
  types: ProjectType[] = [];
  isLoading = true;
  error = '';

  newTypeName = '';
  adding = false;
  addError = '';

  editingId: number | null = null;
  editingName = '';
  saving = false;

  deletingId: number | null = null;

  constructor(private svc: ProjectTypeService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void { this.load(); }

  load(): void {
    this.isLoading = true;
    this.error = '';
    this.svc.getProjectTypes().subscribe({
      next: (data) => { this.types = data; this.isLoading = false; this.cdr.markForCheck(); },
      error: () => { this.error = 'Failed to load project types.'; this.isLoading = false; this.cdr.markForCheck(); },
    });
  }

  startAdd(): void { this.newTypeName = ''; this.addError = ''; }

  submitAdd(): void {
    const name = this.newTypeName.trim();
    if (!name) { this.addError = 'Name is required.'; return; }
    this.adding = true;
    this.svc.create(name).subscribe({
      next: () => { this.adding = false; this.newTypeName = ''; this.load(); },
      error: () => { this.adding = false; this.addError = 'Failed to add. Please try again.'; this.cdr.markForCheck(); },
    });
  }

  startEdit(t: ProjectType): void { this.editingId = t.id; this.editingName = t.type; }
  cancelEdit(): void { this.editingId = null; this.editingName = ''; }

  saveEdit(t: ProjectType): void {
    const name = this.editingName.trim();
    if (!name) { return; }
    this.saving = true;
    this.svc.update(t.id, name).subscribe({
      next: () => { this.saving = false; this.editingId = null; this.load(); },
      error: () => { this.saving = false; this.error = 'Failed to save.'; this.cdr.markForCheck(); },
    });
  }

  confirmDelete(t: ProjectType): void { this.deletingId = t.id; }
  cancelDelete(): void { this.deletingId = null; }

  doDelete(t: ProjectType): void {
    this.svc.delete(t.id).subscribe({
      next: () => { this.deletingId = null; this.load(); },
      error: () => { this.deletingId = null; this.error = 'Failed to delete.'; this.cdr.markForCheck(); },
    });
  }
}
